export const unstuck = {
  id: "unstuck",
  disciplines: "Exhibition, Corporate Identity",
  shortDisciplines: "Exhibition, CI",
  year: 2023,
  project: "(Un)stuck",
  initiatedAt: "FH Salzburg, Austria (Master)",
  shortInitiatedAt: "FHS, AT (MA)",
  thumbnailUrl: "/assets/Unstuck/00-U-1x1-1440-Thumbnail.webp",
  additionalInfo: {
    awards: ["Bronze, ADC Talent Award 2024 (Concept, Spatial Experience)"],
    exhibitions: ["5020 Galerie Salzburg"],
  },
  description:
    '"(Un)stuck" is a group exhibition examining societal and individual states of stagnation. The project presents the independently developed visual identity of the exhibition, based on a typographic system in which letterforms entangle, compress, and confine themselves, forming a visual metaphor for being stuck.',
  credits: [
    "Initiated at MA Communication Design, FH Salzburg, Austria",
    "Mentoring Viktoria Kirjuchina, Shiro Inoue; Photography  Anna-Sophie Wehmeyer",
  ],
  galleryItems: [
    {
      medias: [
        {
          type: "image",
          url: "/assets/Unstuck/01-U-9x11-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-six-lg portrait-media-nine-by-ten",
        },
        {
          type: "image",
          url: "/assets/Unstuck/02-U-9x11-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-seven-lg span-six-lg portrait-media-nine-by-ten",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Unstuck/03-U-9x11-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-six-lg portrait-media-nine-by-ten",
        },
        {
          type: "image",
          url: "/assets/Unstuck/04-U-9x11-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-seven-lg span-six-lg portrait-media-nine-by-ten",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "video",
          sound: true,
          url: "/assets/Unstuck/05-U-16x9-Video.mp4",
          poster: "/assets/Unstuck/05-U-16x9-Video_thumbnail.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-twelve-lg landscape-media-sixteen-by-nine",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Unstuck/06-U-1x1-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-four-lg portrait-media-nine-by-ten",
        },
        {
          type: "image",
          url: "/assets/Unstuck/07-U-9x11-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-six-lg span-seven-lg portrait-media-nine-by-ten",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Unstuck/08-U-16x9-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-twelve-lg landscape-media-sixteen-by-nine",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Unstuck/09-U-1x1-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-six-lg square-media-one-by-one",
        },
        {
          type: "image",
          url: "/assets/Unstuck/10-U-1x1-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-seven-lg span-six-lg square-media-one-by-one",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
  ],
};
